export default __webpack_public_path__ + "static/media/001.1c94eb59.jpg";